import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles(({  variables, palette, breakpoints }) => ({
    scroller: {
      [breakpoints.down('xs')]: {
        top:`calc((100% - 108px) - ${variables?.spacingB})`,
        height:'auto',
        left:variables?.spacingB,
        '& *:not(:first-child)':{
          display:'none'
        }
      },
      padding:variables?.spacingC,
      width:'48px', 
      height:'131px',
      border:`1px solid ${palette?.jet?.borderStrong}`,
      backgroundColor:palette?.jet?.containerDefault,
      position:'fixed', 
      top:'calc((100vh / 2) - 82px)',
      left:'10%',
      zIndex:9,
      borderRadius:variables?.radiusRoundedC,
      boxShadow:variables?.elevation04,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-around',
      alignItems: 'center',
      '& .jetFontIcon': {
        cursor:'pointer',
        color:palette?.jet?.supportBrand01,
      },
      '& .divider': {
        borderTop: `1px solid ${palette?.jet?.dividerDefault}`,
        width: '100%'
      }
    }
}));

export default useStyles;
